export default __webpack_public_path__ + "static/arab-1b9aa1f0e728775aec22a8dcdf017571.svg";